import React from 'react';
import './News.css';

// Newest first. Add new entries to the top of this list.
const NEWS = [
  {
    title: 'Echo Hill put on an amazing set at The Cinders in Sacramento California October 3 2026',
    source: 'The Little Music Magazine',
    date: 'October 7, 2026',
    url: 'https://bymatte.com/2026/10/07/echo-hill-put-on-an-amazing-set-at-the-cinders-in-sacramento-california-october-3-2026/',
    image: 'https://i0.wp.com/bymatte.com/wp-content/uploads/2026/10/0M7A6896.jpg?fit=1080%2C720&ssl=1',
    excerpt: 'On October 3, 2026, I traveled to Sacramento, California, to The Cinders bar and grill. On the agenda for that evening were Banger, Screaming Bloody Mary\u2019s, Streetwalkin\u2019 Cheetahs, and \u2026',
  },
];

export default function News() {
  return (
    <div>
      <div className="section-container">
        <h1 className="section-title">News</h1>
        <div className="section-rule" />

        <div className="news-list">
          {NEWS.map(({ title, source, date, url, image, excerpt }) => (
            <a
              key={url}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="news-card"
            >
              {image && (
                <div className="news-card-image">
                  <img src={image} alt={title} loading="lazy" />
                </div>
              )}
              <div className="news-card-body">
                <p className="news-card-meta">{source} &middot; {date}</p>
                <h2 className="news-card-title">{title}</h2>
                {excerpt && <p className="news-card-excerpt">{excerpt}</p>}
                <span className="news-card-link">Read article &rarr;</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
